import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="py-8 md:py-10 px-4 bg-primary text-white relative overflow-hidden" data-id="element-31">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-32">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[120%] bg-white/5 rotate-12 blur-3xl rounded-full" data-id="element-33"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[100%] bg-accent/10 -rotate-12 blur-3xl rounded-full" data-id="element-34"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-36">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3 font-serif leading-tight" data-id="element-37">
            Empezá hoy a mejorar la vida de tu perro
          </h2>

          <p className="text-lg md:text-xl text-white/80 mb-6 max-w-2xl mx-auto font-medium" data-id="element-38">
            No esperes a que su salud empeore. Podés empezar hoy mismo, de forma
            simple y segura.
          </p>

          <div className="flex justify-center" data-id="element-39">
            <CTAButton className="text-xl md:text-2xl py-5 px-10 !bg-[#E8761A] hover:!bg-[#E8761A] text-white shadow-xl shadow-orange-900/20" text="QUIERO EMPEZAR HOY" data-id="element-40" />
          </div>

          <p className="mt-5 text-sm text-white/60 font-medium" data-id="element-41">
            Pago único • Acceso de por vida • Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}